module.exports = __webpack_public_path__ + "img/t2.edec1655.png";